import PropTypes from 'prop-types';
import React, { useState } from 'react';
// @mui
import { Box, MenuItem, Typography } from '@mui/material';
// hooks
import useLocales from '../../../hooks/useLocales';
// components
import Image from '../../../components/Image';
import MyDialog from '../../../components/dialog-component/my-dialog'; // Custom Dialog
// ----------------------------------------------------------------------

NewLanguagePopover.propTypes = {
  handleClose: PropTypes.func,
  handleOpen: PropTypes.func,
  hasIcon: PropTypes.bool,
  hasLabel: PropTypes.bool,
  open: PropTypes.bool,
};

export default function NewLanguagePopover({ open, handleOpen, handleClose, hasLabel = false, hasIcon = false }) {
  const { allLangs, currentLang, onChangeLang } = useLocales();
  const { translate } = useLocales();
  const [isHover, setIsHover] = useState(false);

  const handleChangeLang = (newLang) => {
    onChangeLang(newLang);
    if (handleClose) handleClose();
    window.location.reload();
  };

  return (
    <>
      {/* Button Trigger */}
      <Box
        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        onClick={handleOpen}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        {hasIcon && (
          <Image
            src={
              isHover
                ? require('../../../assets/home/language-hover.png')
                : require('../../../assets/home/language.png')
            }
            style={{ height: '30px', width: '30px' }}
          />
        )}

        {hasLabel && (
          <Typography fontSize="12px" sx={{ ml: 0.5, color: isHover ? '#F1C40F' : '#000000' }}>
            {translate('change_language')}
          </Typography>
        )}
      </Box>

      {/* Dialog */}
      <MyDialog open={open} close={handleClose}>
        <Typography variant="h6" sx={{ textAlign: 'center', mb: 2, color: '#000000' }}>
          {translate('change_language')}
        </Typography>

        {allLangs.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === currentLang.value}
            onClick={() => handleChangeLang(option.value)}
          >
            <Image src={option.icon} sx={{ width: 28, height: 28, mr: 2 }} />
            <Typography color={'#000000'}> {option.label}</Typography>
          </MenuItem>
        ))}
      </MyDialog>
    </>
  );
}
